import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ChatbotUiService } from '../../../../core/chatbot/chatbot-ui.service';
import { UserService } from '../../../../core/auth/_services/user.service';
import { OffcanvasOptions } from '../../../../core/_base/metronic';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Observable } from 'rxjs';
import { FileBrowserService } from '../../../../core/file-browser/file-browser.service';
import { finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { LayoutUtilsService } from '../../../../core/_base/crud';
import { environment } from '../../../../../environments/environment';
import { ChatbotUIComponent } from '../chatbot-ui/chatbot-ui.component';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-chatbot-opener',
  templateUrl: './chatbot-opener.component.html',
  styleUrls: ['./chatbot-opener.component.scss']
})

export class ChatbotOpenerComponent implements OnInit {
  @ViewChild('ktOffCanvasRef', { static: true }) ktOffCanvasElement;
  @ViewChild(ChatbotUIComponent) chatbotUIComponent: ChatbotUIComponent;
  @Input() mobileView: boolean = false;
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'kt-quick-panel',
    closeBy: 'customer_form_close_btn',
    toggleBy: 'configuration_panel_toggler_btn'
  };

  constructor(
    private readonly chatbotService: ChatbotUiService,
    private readonly userService: UserService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly fileBrowserService: FileBrowserService,
    private readonly layoutUtilsService: LayoutUtilsService,
  ) { }

  ngOnInit(): void {
  }

  toggleChatbox() {
    if (this.mobileView) {
      this.router.navigate(['/web/genai']);
    }
    else {
      this.ktOffCanvasElement.offcanvas.show();
      this.chatbotUIComponent.getBotResponse();
    }
  }

  close() {
    this.ktOffCanvasElement.offcanvas.hide();
  }
}
